import { SVGProps } from "react";

const Cross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={58}
    height={58}
    viewBox="5 0 48 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0835 12.082L45.9149 45.9134"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0851 45.9134L45.9165 12.082"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Cross;
